import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-file" }
const _hoisted_2 = ["accept"]

import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-file',
  props: {
    extensions: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const fileName = ref(null);
const dragging = ref(false);

const accepts = computed(() => props.extensions?.join(",") || "");

function readFile(file: any) {
  const reader = new FileReader();
  reader.onload = () => {
    const infos = reader?.result?.split(",")[0];
    const base64String = reader?.result?.split(",")[1];
    const fileExtension = file.name.split(".").pop();
    fileName.value = file.name;

    emit("change", {
      name: file.name,
      infos: infos,
      extension: fileExtension,
      file: base64String,
      size: file.size,
    });
  };
  reader.readAsDataURL(file);
}

function fileSelect(event: any) {
  const files = event?.target?.files;
  if (files.length > 0) {
    readFile(files[0]);
  }
}

function fileDrop(event: any) {
  dragging.value = false;
  const droppedFiles = event.dataTransfer.files;
  if (droppedFiles.length > 0) {
    readFile(droppedFiles[0]);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["drop-area", { dragging: dragging.value }]),
      onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
      onDragenter: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (dragging.value = true), ["prevent"])),
      onDragleave: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (dragging.value = false), ["prevent"])),
      onDrop: _withModifiers(fileDrop, ["prevent"]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.fileInput.click()))
    }, _toDisplayString(fileName.value ? fileName.value : _unref(t)("common.texts.file_upload")), 35),
    _createElementVNode("input", {
      ref: "fileInput",
      type: "file",
      onChange: fileSelect,
      accept: accepts.value
    }, null, 40, _hoisted_2)
  ]))
}
}

})